const ArrowPrev = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="12"
            fill="none"
            viewBox="0 0 9 12"
            {...props}
        >
            <path fill="#000" d="M0 6L9 .804v10.392L0 6z" />
        </svg>
    )
}

export default ArrowPrev
